import { FormFieldValue } from '../Form.types';
import { FIELD_TO_COOKIE_KEY } from './constants';

export { readSubmittedFormData, storeSubmittedFormData, clearSubmittedFormData } from './knownVisitor';

export const cookieDataToFormValues = (cookieData: Record<string, string>): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const [formKey, cookieKey] of Object.entries(FIELD_TO_COOKIE_KEY)) {
    if (cookieData[cookieKey]) result[formKey] = cookieData[cookieKey];
  }
  return result;
};

export const formValuesToCookieData = (values: Record<string, FormFieldValue>): Record<string, string> => {
  const result: Record<string, string> = {};
  for (const [formKey, cookieKey] of Object.entries(FIELD_TO_COOKIE_KEY)) {
    const value = values[formKey];
    if (value) result[cookieKey] = value;
  }
  return result;
};
